import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class MarketMarketratesExportController extends Controller {
  @service router;

  @controller('market.marketrates') rates;

  get tabsParams() {
    return {
      // Rate options
      maxInterval: 90,
      los: this.rates?.los,
      mealPlan: this.rates?.mealPlan,
      maxPersons: this.rates?.maxPersons,
      roomType: this.rates?.roomType,
      rateParam: this.rates?.rateParam,
      membershipType: this.rates?.membershipType,
      platform: this.rates?.platform,
      rateChanges: this.rates?.rateChanges,
      compareType: this.rates?.compareType,
      compareValue: this.rates?.compareValue,
      // Needs to be bound to rates to enable the correct context
      defaultRateChanges: this.rates?.defaultRateChanges.bind(this.rates),
      managementTypes: this.rates?.managementTypes,
      brands: this.rates?.brands,
      compsetId: this.rates?.compsetId,
      otaId: this.rates?.otaId,
      selectedOTA: this.rates?.selectedOTA,
      // Export options
      hasLiveShop: false,
      page: this.rates?.page,
    };
  }

  @action
  closeModal() {
    this.router.legacyTransitionTo('market.marketrates');
  }
}
